import React, {useState} from 'react';

export default function SpecialtyDetails({department}) {
    if (!department) {
        return null;
    }

    return (
        <section className="specialty-detail">
            <h2 className="specialty-details-title">{department.department_name}</h2>

            <div className="specialty-details-content">
                <div className="specialty-image-details">
                    <img
                        src={department.image_url || '/bw_image/specialty-details-dump.png'}
                        alt={department.department_name}
                    />
                </div>
                <div className="specialty-details-description">
                    <p>{department.description || 'Thông tin chi tiết về chuyên khoa sẽ được cập nhật sớm nhất.'}</p>
                </div>
            </div>
        </section>
    );
}
